import { Portal } from '@material-ui/core';
import { Observer } from 'mobx-react';
import React from 'react';
import { FBDialog, FBForm, FBLock, FBProvider, FBSnackbar, FBWorkspaceMemo, FBWorkspaceModeOptions, FBWorkspaceProps } from '..';
import { withFBWorkspace } from './FBWorkspace.wrap';
import FBWorkspaceAutosave from './FBWorkspaceAutosave';

const WorkspaceMemoWrapper: React.FC<{
  isPortal?: boolean
  portalContainer?: React.RefObject<HTMLElement>
  children: React.ReactNode
}> = ({
  isPortal,
  portalContainer,
  children,
}) => {
  if (isPortal) {
    if (portalContainer?.current) {
      return (
        <Portal container={portalContainer?.current}>
          {children}
        </Portal>
      );
    } else {
      return <></>;
    }
  }

  return <>{children}</>;
};

const FBWorkspace: React.FunctionComponent<FBWorkspaceProps> = ({
  workspaceState,
  children,
  portalContainer,
  formState,
  dialogState,
  snackbarState,
  mode,
  initialValues,
  schema,
  includeTransport,
  isPortal,
  _tabsState,
  isStarterRequired,
  withoutBottomBar = false,
}) => (
  <FBProvider {...{ workspaceState, dialogState, snackbarState }}>
    <FBSnackbar autoHideDuration={6000} />
    <FBDialog />
    <FBForm
      {...{ initialValues, formState }}
      workspaceMode={mode ?? workspaceState?.mode ?? FBWorkspaceModeOptions.NONE}
      initialValidation
      includeLocking
      initializeMPIFromWorkspace
    >
      <FBWorkspaceAutosave schema={schema} />
      <FBLock>
        <>
          {children}
          <Observer>
            {() => (
              <>
                {workspaceState?.active && (
                  <WorkspaceMemoWrapper {...{ isPortal, portalContainer }}>
                    <FBWorkspaceMemo
                      {...{ includeTransport, workspaceState, _tabsState }}
                      isStarter={isStarterRequired?.()}
                      mode={workspaceState?.mode}
                      schema={workspaceState?.schema}
                      withoutBottomBar={withoutBottomBar}
                    />
                  </WorkspaceMemoWrapper>
                )}
              </>
            )}
          </Observer>
        </>
      </FBLock>
    </FBForm>
  </FBProvider>
);

export default withFBWorkspace(FBWorkspace);
